import React, { Fragment } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";

import styles from "./Icons.styles";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Icons = ({ elements }) => {
	const { REACT_APP_PATH } = process.env;
	const css = styles();

	return (
		<div className={clsx(css.icons, "mco-icons")}>
			{elements?.map(({ elements: items = [] }, index) => {
				const media = items?.find(({ tag }) => tag === "valIcon")?.media?.[0];

				const { filename } = media || {};

				if (!filename) return <Fragment key={index}></Fragment>;

				return (
					<div className={clsx(css.item, "mco-icons__item")} key={index}>
						<ReactSVGIcon
							color="initial"
							key={index}
							src={`${REACT_APP_PATH}${filename}`}
							size={50}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default Icons;
